import baseAPI from '../axiosApi'

const api={
    list:'/api-ir/research/assess/page',
    info:'/api-ir/research/assess/get/',
    add:'/api-ir/research/assess/add',
    del:'/api-ir/research/assess/delete/',
    commit:'/api-ir/research/assess/submit/',
    edit:'/api-ir/research/assess/edit',
    approve:'/api-ir/research/assess/approve',
    confirm:'/api-ir/research/assess/confirm/',
    approveEdit:'/api-ir/research/assess/approveDetail',
    exportTable:'/api-ir/research/assess/export/'
}
export function list (data) {
    return baseAPI.axiosData(api.list,'get',data)
}
export function info (data) {
    return baseAPI.axiosData(api.info+data,'get')
}
export function add (data) {
    return baseAPI.axiosData(api.add,'post',data)
}
export function del (data) {
    return baseAPI.axiosData(api.del+data,'delete')
}
export function commit (data) {
    return baseAPI.axiosData(api.commit+data,'post')
}
export function edit (data) {
    return baseAPI.axiosData(api.edit,'put',data)
}
export function approve (data) {
    return baseAPI.axiosData(api.approve,'post',data)
}
export function confirm (data) {
    return baseAPI.axiosData(api.confirm+data,'post')
}
export function approveEdit (data) {
    return baseAPI.axiosData(api.approveEdit,'put',data)
}
export function exportTable (data) {
    return baseAPI.axiosData(api.exportTable+data,'post')
}